export async function postRegister(body, cb = () => {}) {
  const response = await fetch(`/api/register`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
  });
  if (response.ok) {
      const data = await response.json();
      cb(null,data);
  } else {
      cb(response.status);
  }
}


export async function getRegions({}, cb = () => {}) {
    const response = await fetch(`/api/register/regions`, {
        method: 'get'
    });
    if (response.ok) {
        const data = await response.json();
        cb(null,data);
    } else {
        cb(response.status);
    }
}

export async function checkAvailability({ email, phone }) {
  const params = new URLSearchParams();
  if (email)  params.append('email', email);
  if (phone)  params.append('phone', phone);

  const response = await fetch(`/api/register/check?${params.toString()}`);
  return response.json(); 
}